import React from 'react';
import { Box } from '@mui/material';

import MobilityVehiclesContent from './components/MobilityVehiclesContent';

/** Mounted on both the Mobile Service and Parts Delivery shells. Self-padded like the other product
 *  tabs, with no page title because the shell band and tab strip already name it. */
const ServiceVehiclesTab: React.FC = () => (
  <Box sx={{ p: 2 }}>
    <MobilityVehiclesContent />
  </Box>
);

export default ServiceVehiclesTab;
